@if (!loading) {
  <div class="relative overflow-hidden rounded-xl mx-4 p-5 transition-all duration-300 hover:shadow-xl group border"
     [ngClass]="{
       'border-red-500 dark:border-red-700 shadow-sm shadow-red-500/10 bg-red-300 dark:bg-red-900/60': _packageInfo === null || getProgressBarColor() === 'red',
       'border-orange-500 dark:border-orange-700 shadow-sm shadow-orange-500/10 bg-orange-300 dark:bg-orange-900/60': _packageInfo !== null && getProgressBarColor() === 'yellow',
       'border-green-500 dark:border-green-700 shadow-sm shadow-green-500/10 bg-green-300 dark:bg-green-800/60': _packageInfo !== null && getProgressBarColor() === 'primary'
     }">

    <!-- Content -->
    <div class="relative z-10 flex flex-col gap-3">

      <!-- Header with icon -->
      <div class="flex items-center gap-3">
        @if (mode === 'mobile') {
          <div class="flex items-center justify-center w-12 h-12 rounded-xl transition-all duration-300"
               [ngClass]="{
                 'bg-red-700 dark:bg-red-800/50 text-white dark:text-red-200': _packageInfo === null || getProgressBarColor() === 'red',
                 'bg-orange-700 dark:bg-orange-800/50 text-white dark:text-orange-200': _packageInfo !== null && getProgressBarColor() === 'yellow',
                 'bg-green-700 dark:bg-green-800/50 text-white dark:text-green-200': _packageInfo !== null && getProgressBarColor() === 'primary'
               }">
            <i class="text-xl" [class]="getIconClass()"></i>
          </div>
        }

        <div class="flex-1">
          <h3 class="font-semibold text-base"
              [ngClass]="{
                'text-red-900 dark:text-red-100': _packageInfo === null || getProgressBarColor() === 'red',
                'text-orange-900 dark:text-orange-100': _packageInfo !== null && getProgressBarColor() === 'yellow',
                'text-green-900 dark:text-green-100': _packageInfo !== null && getProgressBarColor() === 'primary'
              }">
            {{ _packageInfo?.name ?? ('ui.sidebarTile.noActivePackage' | translate) }}
          </h3>
        </div>
      </div>

      <!-- Progress section -->
      <div class="flex flex-col gap-2.5">
        @if (_packageInfo) {
          <!-- Progress bar -->
          <div class="flex flex-col gap-1.5">
            <div class="relative w-full h-3 rounded-full overflow-hidden bg-black/20 dark:bg-white/10">
              <div class="absolute left-0 top-0 h-full rounded-full transition-all duration-700 ease-out shadow-sm"
                   [style.width]="calculateProgressPercentage() + '%'"
                   [ngClass]="{
                     'bg-red-800 dark:bg-red-500': getProgressBarColor() === 'red',
                     'bg-orange-800 dark:bg-orange-400': getProgressBarColor() === 'yellow',
                     'bg-green-800 dark:bg-green-500': getProgressBarColor() === 'primary'
                   }">
                <!-- Shimmer animation -->
                <div class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer"></div>
              </div>
            </div>

            <!-- Progress label -->
            @if (_packageInfo !== null) {
              <div class="flex items-center text-sm font-medium"
                   [ngClass]="{
                     'text-red-900 dark:text-red-200': getProgressBarColor() === 'red',
                     'text-orange-900 dark:text-orange-200': getProgressBarColor() === 'yellow',
                     'text-green-900 dark:text-green-200': getProgressBarColor() === 'primary'
                   }">
                @if (_packageInfo?.state !== null) {
                  <span class="font-semibold">{{ 'ui.sidebarTile.cardCount' | translate }}: <span class="text-base">{{ getProgress() }}</span></span>
                } @else {
                  <span class="font-semibold flex items-center gap-1">
                    <i class="pi pi-infinity text-xs"></i>
                    <span>{{ 'ui.sidebarTile.unlimited' | translate }}</span>
                  </span>
                }
              </div>
            }
          </div>

          <!-- Expiry date -->
          <div class="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs"
               [ngClass]="{
                 'bg-red-700/40 dark:bg-red-900/50 text-red-950 dark:text-red-100': getProgressBarColor() === 'red',
                 'bg-orange-700/40 dark:bg-orange-900/50 text-orange-950 dark:text-orange-100': getProgressBarColor() === 'yellow',
                 'bg-green-700/40 dark:bg-green-900/50 text-green-950 dark:text-green-100': getProgressBarColor() === 'primary'
               }">
            <i class="pi pi-calendar opacity-80 text-xs"></i>
            <span>{{ 'ui.sidebarTile.validUntil' | translate }}: <strong class="font-medium">{{ _packageInfo?.endDate | date }}</strong></span>
          </div>
        } @else {
          <!-- No package CTA -->
          <button class="flex items-center justify-center gap-2 w-full px-4 py-2.5 bg-primary-600 hover:bg-primary-700 dark:bg-primary-700 dark:hover:bg-primary-800 text-white font-medium rounded-lg transition-all duration-300 hover:shadow-md text-sm group/btn"
                  (click)="router.navigate(['/dashboard/store/plans'])">
            <i class="pi pi-shopping-cart text-sm"></i>
            <span>{{ 'ui.sidebarTile.buyPackage' | translate }}</span>
            <i class="pi pi-arrow-right text-xs transition-transform group-hover/btn:translate-x-0.5"></i>
          </button>
        }
      </div>
    </div>
  </div>
}

@if (loading) {
  <p-skeleton styleClass="mx-4" height="7rem" borderRadius="12px"></p-skeleton>
}
